import type { ComandaStatus } from '@/db/dexie'
import { statusMeta } from '@/lib/format'
import { cn } from '@/lib/utils'

/**
 * Maps a comandă status to its warm-editorial label + color chip.
 * Colors come from `statusMeta` in `lib/format.ts` (single source of truth).
 */
export function StatusBadge({
  status,
  showDot = true,
  className,
}: {
  status: ComandaStatus
  showDot?: boolean
  className?: string
}) {
  const m = statusMeta[status]
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-md px-2 py-0.5 text-xs font-medium whitespace-nowrap',
        className,
      )}
      style={{ backgroundColor: m.bg, color: m.fg }}
    >
      {showDot && (
        <span className="size-1.5 rounded-full" style={{ backgroundColor: m.dot }} aria-hidden />
      )}
      {m.label}
    </span>
  )
}
